import set from 'lodash/set';

export function getAdHocDefaultValues(outerName, questions = []) {
  const defaultValues = {};

  questions.forEach(({ type, name, value, options = [] }) => {
    if (type === 'CHECKBOX_GROUP') {
      const values = {};

      options.forEach(({ value: innerValue, checked, freeText }) => {
        if (freeText) {
          values.__other__ = innerValue;
          values.__checkbox__ = !!checked;
        } else {
          values[innerValue] = !!checked;
        }
      });

      set(defaultValues, name, values);
    } else if (type === 'RADIO') {
      const freeTextOption = options.find((option) => option.freeText);

      if (freeTextOption?.value) {
        const innerValue = freeTextOption.value;
        set(defaultValues, `${name}.__other__`, innerValue);
        set(defaultValues, `${name}.__radio__`, '__checked__');
      } else {
        set(defaultValues, `${name}.__radio__`, value);
      }
    } else if (['FILE', 'FILE_GROUP'].includes(type)) {
      const values = options.map(({ path, size }) => ({ path, size }));
      set(defaultValues, name, values);
    } else {
      set(defaultValues, name, value);
    }
  });

  return { [outerName]: { ...defaultValues } };
}
